import validateCallback from "./validateCallback";
import validateElement from "./validateElement";
import validateEventName from "./validateEventName";
import validateEventTrigger from "./validateEventTrigger";
import validateString from "./validateString";
import validateUrls from "./validateUrls";

module.exports = {
  validateCallback,
  validateElement,
  validateEventName,
  validateEventTrigger,
  validateString,
  validateUrls
};



// WEBPACK FOOTER //
// ./src/validators/index.js